let g_codes = {
	custom: `
<script src="squery.min.js"></script>
<script>
const $ = sq
$(function(){
	$('body')
		.html('<div class="str">Am I jQuery?</div>')
		.css('background', 'rgb(230,30,100)')
	
	$('.str').css({
		color: '#fff',
		fontSize: '20px',
	})
})
</script>
	`,

	custom_module: `
<script type="module">
import {sq as $} from './sq.min.js'
$(function(){
	$('body').css('background', 'rgb(230,30,100)')
	$('body').html('Am I jQuery?')
})
</script>
	`,

	with_jquery: `
<script src="https://code.jquery.com/jquery-3.6.1.min.js"></script>
<script src="squery.min.js"></script>
<script>
$(function(){
	// jQuery code!
	$('body').html('<div class="str">I am jQuery!</div>')
	
	// sQuery code!
	sq('body').append('<div class="str">I am sQuery!</div>')

	// sQuery code!
	sq('.str').css({
		'color': '#fff',
		'background': 'rgb(50,140,255)',
		'padding': '10px',
		'margin': '10px'
	})
	
	// jQuery code!
	$('.str').eq(0).css('background', 'rgb(20,20,90)')
})
</script>
	`,


	c1: `
<script src="squery.min.js"></script>
<script>
sq(function(){
	sq('body').css('background', 'skyblue')
	sq('body').html('<h1>Hello sQuery!</h1>')
})
</script>`,

	c1_cdn: `
<script src="https://cdn.jsdelivr.net/gh/exis9/squery@latest/squery.min.js"></script>
<script>
sq(function(){
	sq('body').css('background', 'skyblue')
	sq('body').html('<h1>Hello sQuery CDN!</h1>')
})
</script>`,
	
	c2: `
<script type="module">
import {sq} from './sq.min.js'
sq(()=>{
	sq('body').css('background', 'rgb(230,30,100)')
	sq('body').html('<h1>Hi, sQuery module!</h1>')
})
</script>`,

c2_cdn: `
<script type="module">
import {sq} from 'https://cdn.jsdelivr.net/gh/exis9/squery@latest/sq.min.js'
sq(()=>{
	sq('body').css('background', 'rgb(230,30,100)')
	sq('body').html('<h1>Hi, sQuery CDN module!</h1>')
})
</script>`,

customMethods: `
<span>click me!</span>

<script>
	_SQ.NewMethod = function(){ //_SQ.MethodName creates a new method!
		alert("hello")
		return this //if you need the method chain, don't forget this
	}

	_SQ.BgChange = function( color ){
		let el = this.el[0] //the first element chosen by the selector
		el.style.background = color //css styling
		return this
	}

	sq('span').on( 'click', ()=>{
		sq('body').BgChange('red') //changes the background
		setTimeout(()=>{
			sq('body').NewMethod().BgChange('skyblue') //alerts hello and then changes the background
		}, 1000)
	})
</script>
`,

reactScript: `
<script src="https://cdn.jsdelivr.net/gh/exis9/squery@latest/squery.min.js"></script>
<script>
sq(()=>{
	sq('body').css('background', 'skyblue')
	sq('body').prepend('<h1>Hello sQuery CDN!</h1>')
})
</script>
`,
reactModule: `
import { sq } from './sq.js';
sq('body').prepend('<h1>Hello sQuery!</h1>')
`,

nextScript: `
<script src="https://cdn.jsdelivr.net/gh/exis9/squery@latest/squery.min.js"></script>
<script src="/test.js"></script>
`,
nextScript2: `
sq('body').prepend('<h1 id="sQueryH1">Hello sQuery! (Next.js)</h1>')
sq('#sQueryH1').css('color', 'green')
`,
nextModule: `
<script src="/test.js" type="module"></script>
`,
nextModule2: `
import { sq } from 'https://cdn.jsdelivr.net/gh/exis9/squery@latest/sq.min.js';

sq('body').prepend('<h1>Hello sQuery (Next.js)!</h1>')
sq('#sQueryH1').css('color', 'red')
`,


vueScript: `
<script src="https://cdn.jsdelivr.net/gh/exis9/squery@latest/squery.min.js"></script>
<script>
	sq(()=>{
		sq('body').css('background', 'skyblue')
		sq('body').prepend('<h1 style="color:green">Hello sQuery CDN! (Vue)</h1>')
	})
</script>
`,
vueScriptES6: `
<script type="module">
	import {sq} from "https://cdn.jsdelivr.net/gh/exis9/squery@latest/sq.min.js"
	sq(()=>{
		sq('body').css('background', 'skyblue')
		sq('body').prepend('<h1 style="color:green">Hello sQuery CDN! (Vue)</h1>')
	})
</script>
`,
vueModule: `
import {sq} from "https://cdn.jsdelivr.net/gh/exis9/squery@latest/sq.min.js"

sq('body').css('background', 'skyblue')
sq('body').prepend('<h1 style="color:red">Hello sQuery CDN! (Vue)</h1>')
`,
vueModule2: `
import {} from "./test.js"
`,

nuxtModule: `
import { sq } from '../static/sq.js';
sq('body').prepend('<h1>Hello sQuery!(Nuxt.js)</h1>')
`,

svelteScript: `
<script src="https://cdn.jsdelivr.net/gh/exis9/squery@latest/squery.min.js"></script>
<script>
sq(()=>{
	sq('body').css('background', 'skyblue')
	sq('body').prepend('<div style="padding:8px">Hello sQuery! (Svelte)</div>')
})
</script>
`,
svelteModule: `
import { sq } from './sq.js';
sq('body').prepend('<div style="padding:8px;color:green">Hello sQuery! (Svelte)</div>')
`,

sveltekitScript: `
<script src="https://cdn.jsdelivr.net/gh/exis9/squery@latest/squery.min.js"></script>
<script>
sq(()=>{
	sq('body').css('background', 'skyblue')
	sq('body').prepend('<div style="padding:8px">Hello sQuery! (Sveltekit)</div>')
})
</script>
`,
sveltekitModule: `
import { sq } from '../sq.js';
sq('body').prepend('<div style="padding:8px;color:green">Hello sQuery! (Sveltekit)</div>')
`,


solidjsScript: `
<script src="https://cdn.jsdelivr.net/gh/exis9/squery@latest/squery.min.js"></script>
<script>
sq(()=>{
	sq('body').css('background', 'skyblue')
	sq('body').prepend('<h1>Hello sQuery CDN!(SolidJS)</h1>')
})
</script>
`,
solidjsModule: `
import { sq } from './sq.js';
sq('body').prepend('<h1>Hello sQuery!(SolidJS)</h1>')
`,

filter: `
<div>a</div>
<div class="middle">b</div>
<div class="middle2">c</div>
<div class="middle">d</div>
<div class="middle">e</div>
<div>f</div>

<script>
sq(()=>{
	sq('div')
		.css('background', '#c8ebcc')
		.filter('.middle' )
		.css('color', 'red');
})
</script>`,

not: `
<div> a </div>
<div id="pokemon"> b </div>
<div> c </div>
<div class="pikachu"> d </div>
<div class="mew"> e </div>
<div class="mewtwo"> f </div>
<div> g </div>
 
<script>
	sq("div")
		.not("#pokemon, .mewtwo")
		.css("color", "red");
</script>
`,

eq: `
<style>
div {
	border: 1px solid blue;
	margin: 10px;
	padding: 10px;
}
.blue {
	color: white;
	background: blue;
}
</style>

<div>0</div>
<div>1</div>
<div>2</div>
<div>3</div>
<div>4</div>
<div>5</div>

<script>
	sq( "body" ).find( "div" ).eq( 2 ).addClass( "blue" );
</script>
`,

eq2: `
<style>
div {
	border: 1px solid red;
	margin: 10px;
	padding: 10px;
}
.red {
	color: white;
	background: red;
}
</style>

<div>0</div>
<div>1</div>
<div>2</div>
<div>3</div>
<div>4</div>
<div>5</div>
 
<script>
	sq( "body" ).find( "div" ).eq( -2 ).addClass( "red" );
</script>
`,

first: `
<ul>
  <li>first</li>
  <li>second</li>
  <li>third</li>
  <li>forth(last)</li>
</ul>

<script>
	sq('ul li').first().css('color', 'red')
</script>
`,

last: `
<ul>
	<li>first</li>
	<li>second</li>
	<li>third</li>
	<li>forth(last)</li>
</ul>

<script>
	sq('ul li').last().css('color', 'red')
</script>
`,

has: `
<ul>
  <li>list item 1</li>
  <li>list item 2
    <ul>
      <li>list item 2-a</li>
      <li>list item 2-b</li>
    </ul>
  </li>
  <li>list item 3</li>
  <li>list item 4</li>
</ul>

<script>
	sq( "li" ).has( "ul" ).css( "background-color", "red" );
</script>
`,

contains: `
<div>RX78-2 GUNDAM</div>
<div>C3PO</div>
<div>Megaman X</div>
<div>Evangelion Unit-01</div>
 
<script>
	sq( "div" ).contains( "Megaman" ).css( "text-decoration", "underline" );
</script>
`,

slice: `
<ul>
  <li>list item 1</li>
  <li>list item 2</li>
  <li>list item 3</li>
  <li>list item 4</li>
  <li>list item 5</li>
</ul>

<script>
	sq( "li" ).slice( 1 ).css( "background-color", "red" );
	//sq( "li" ).slice( 2, 4 ).css( "background-color", "yellow" );
</script>
`,

index: `
<ul>
	<li id="jojo">JoJo's Bizarre Adventure</li>
	<li id="dbz">Dragon Ball Z</li>
	<li id="naruto">Naruto</li>
</ul>
<div id="msg"></div>
<script>
	sq('#msg').text( "Index of Dragn Ball Z: " + sq( "#dbz" ).index() )
</script>
`,

is: `
<ul>
	<li>list <strong>item 1</strong></li>
	<li><span>list item 2</span></li>
	<li>list item 3</li>
</ul>
<script>
	sq( "ul" ).on('click', function( event ) {
		var target = sq( event.target );
		if ( target.is( "li" ) ) {
			target.css( "background-color", "red" );
		}
	});
</script>
`,

find: `
<ul class="level-1">
	<li class="item-i">I</li>
	<li class="item-ii">
		II
		<ul class="level-2">
			<li class="item-a">A</li>
			<li class="item-b">B
			<ul class="level-3">
				<li class="item-1">1</li>
				<li class="item-2">2</li>
				<li class="item-3">3</li>
			</ul>
			</li>
			<li class="item-c">C</li>
		</ul>
	</li>
	<li class="item-iii">III</li>
</ul>
<script>
	sq( "li.item-ii" ).find( "li" ).css( "background-color", "red" );
</script>
`,

children: `
<ul class="level-1">
  <li class="item-i">I</li>
  <li class="item-ii">II
    <ul class="level-2">
      <li class="item-a">A</li>
      <li class="item-b">B
        <ul class="level-3">
          <li class="item-1">1</li>
          <li class="item-2">2</li>
          <li class="item-3">3</li>
        </ul>
      </li>
      <li class="item-c">C</li>
    </ul>
  </li>
  <li class="item-iii">III</li>
</ul>

<script>
	sq( "ul.level-3" ).children().css( "background-color", "red" );
</script>
`,

next: `
<ul>
  <li>list item 1</li>
  <li>list item 2</li>
  <li class="third-item">list item 3</li>
  <li>list item 4</li>
  <li>list item 5</li>
</ul>

<script>
	sq( "li.third-item" ).next().css( "background-color", "red" );
</script>
`,

prev: `
<ul>
  <li>list item 1</li>
  <li>list item 2</li>
  <li class="third-item">list item 3</li>
  <li>list item 4</li>
  <li>list item 5</li>
</ul>

<script>
	sq( "li.third-item" ).prev().css( "background-color", "red" );
</script>
`,

siblings: `
<ul>
	<li>list item 1</li>
	<li>list item 2</li>
	<li class="third-item">list item 3</li>
	<li>list item 4</li>
	<li>list item 5</li>
</ul>

<script>
	sq( "li.third-item" ).siblings().css( "background-color", "red" );
</script>
`,

parent:`
<ul class="level-1">
  <li class="item-i">I</li>
  <li class="item-ii">II
    <ul class="level-2">
      <li class="item-a">A</li>
      <li class="item-b">B
        <ul class="level-3">
          <li class="item-1">1</li>
          <li class="item-2">2</li>
          <li class="item-3">3</li>
        </ul>
      </li>
      <li class="item-c">C</li>
    </ul>
  </li>
  <li class="item-iii">III</li>
</ul>

<script>
	sq( "li.item-a" ).parent().css( "background-color", "red" );
</script>
`,

parents:`
<ul class="level-1">
  <li class="item-i">I</li>
  <li class="item-ii">II
    <ul class="level-2">
      <li class="item-a">A</li>
      <li class="item-b">B
        <ul class="level-3">
          <li class="item-1">1</li>
          <li class="item-2">2</li>
          <li class="item-3">3</li>
        </ul>
      </li>
      <li class="item-c">C</li>
    </ul>
  </li>
  <li class="item-iii">III</li>
</ul>

<script>
	sq( "li" ).css( "background-color", "pink" )
	sq( "li.item-a" ).parents().css( "background-color", "red" );
</script>
`,

closest:`
<ul id="one" class="level-1">
  <li class="item-i">I</li>
  <li id="ii" class="item-ii">II
    <ul class="level-2">
      <li class="item-a">A</li>
      <li class="item-b">B
        <ul class="level-3">
          <li class="item-1">1</li>
          <li class="item-2">2</li>
          <li class="item-3">3</li>
        </ul>
      </li>
      <li class="item-c">C</li>
    </ul>
  </li>
  <li class="item-iii">III</li>
</ul>

<script>
	sq( "li.item-a" )
		.closest( "ul" )
		.css( "background-color", "red" );
</script>
`,

hasClass:`
<style>
	.selected {
		color: red;
	}
</style>

<p>This paragraph is black and is the first paragraph.</p>
<p class="selected">This paragraph is red and is the second paragraph.</p>

<br><br>

<div id="result1">First paragraph has selected class: </div>
<div id="result2">Second paragraph has selected class: </div>
<div id="result3">At least one paragraph has selected class: </div>

<script>
	sq( "#result1" ).append( sq( "p" ).first().hasClass( "selected" ).toString() );
	sq( "#result2" ).append( sq( "p" ).last().hasClass( "selected" ).toString() );
	sq( "#result3" ).append( sq( "p" ).hasClass( "selected" ).toString() ) ;
</script>
`,

isVisible:`
<div id="a">a</div>
<div id="b">b</div>
<div id="c" style="display:none">c</div>
<div id="d">d</div>

<div id="console"></div>

<script>
	setTimeout(()=>{
		const a = sq('#a').isVisible().toString()
		const b = sq('#b').isVisible().toString()
		const c = sq('#c').isVisible().toString()
		const d = sq('#d').isVisible().toString()
	
		sq('#console').html( 'a:'+a+', ' + 'b:'+b+', ' + 'c:'+c+', ' + 'd:'+d)
	}, 1000)
</script>
`,


html:`
<div>
	<div>Hello! I'm PS5!!</div>
	<div>Hello! I'm Xbox Series X!!</div>
	<div class="alexa">Hello! I'm Alexa!!</div>
	<div>Konichiwa! I'm Shinzo Abe!!</div>
	<div>Hi! I'm Yamagami!!</div>
	<div>Ha! I'm Donald Trump!!</div>
	<div>Ha! I'm Merkel!!</div>
	<div>WRYYY! I'm Shi Jinping!! Fuck Taiwan!</div>
	<div>I'm TSMC! Taiwan #1!</div>
</div>
<br><br>
Output: <div id="console"></div>

<script>
	let h = '<b>' + sq('.alexa').html() + '</b>'
	sq('#console').html( h )
</script>
`,

text:`
<div>
	<div>Hello! I'm PlayStation 5!!</div>
	<div>Hello! I'm Xbox Series S!!</div>
	<div class="alexa">Hello! I'm <span style="color:red">Alexa</span>!!</div>
	<div>Pika! I'm Pikachu!!</div>
	<div>Hi! I'm Siri!!</div>
	<div>Hi! I'm Bitcoin!!</div>
</div>
<br><br>
Output: <div id="console"></div>

<script>
	// html tags are ignored when you get a text using text()
	let h = '<b>' + sq('.alexa').text() + '</b>' 
	
	// html tags are automatically converted to a normal text
	sq('#console').text( h ) 
</script>
`,

val:`
<input type="text" value="Mewtwo">
<div id="console"></div>
<script>
	sq('input[type="text"]').on('keyup', function(){
		const v = sq(this).val()
		sq('#console').html( 'The strongest pokemon: ' + v )
	})
	sq('input[type="text"]').trigger('keyup')
</script>
`,

css:`
<div id="css1">css1</div>
<div id="css2" style="color:red;font-size:20px">css2</div>
<div id="css3">css3</div>
<div id="css4">css4</div>
<div id="css5">css5</div>
<script>
	const cssText = sq('#css2').css()
	sq('#css3').css('color', cssText.color )
	sq('#css4').css({
		color: cssText.color,
		fontSize: cssText.fontSize,
		//'font-size': cssText['font-size'] is also fine!
	})
	sq('#css5').css('font-size', sq('#css2').css('font-size') )
</script>
`,

attr:`
Click the best Final Fantasy.<br><br>
<div data-text="7">Final Fantasy Ⅶ</div>
<div data-text="8">Final Fantasy Ⅷ</div>
<div data-text="9">Final Fantasy Ⅸ</div>
<div data-text="10">Final Fantasy X</div>
<div data-text="11">Final Fantasy 11</div>
<div data-text="12">Final Fantasy 12</div>
<div data-text="13">Final Fantasy 13</div>
<div data-text="14">Final Fantasy 14</div>
<div data-text="15">Final Fantasy 15</div>
<div data-text="16">Final Fantasy 16</div>

<script>
	sq('div').on('click', function(){
		const ff = sq(this).attr('data-text')
		alert( 'Your Best Final Fantasy is.. Final Fantasy ' + ff )
	})
</script>
`,

prop:`
<input id="check1" type="checkbox" checked="checked"> 
<button>Click me!!</button>

<script>
	sq('button').on('click', function(){
		const b = sq('#check1').prop( 'checked' )
		sq('#check1').prop( 'checked', !b )
	})
</script>
`,

get:`
<ul>
  <li id="t1">The Terminator 1</li>
  <li id="t2">The Terminator 2</li>
</ul>
<script>
	// getting the 2nd li as a native JavaScript Object (not sQuery object)
	const js_object = sq( "li" ).get( 1 )
	// setting the innerHTML with a native JavaScript code
	js_object.innerHTML = 'The Terminator 2（master piece）'
</script>
`,

show:`
<ul>
  <li id="t1">The Terminator 1</li>
  <li id="t2">The Terminator 2</li>
  <li id="t3">The Terminator 3</li>
  <li id="t4" style="display:none">The Terminator 4</li>
</ul>
<button>click me!</button>
<script>
	sq('button').on('click', function(){
		sq('#t3').hide()
		sq('#t4').show()
		alert('T3 does not exist. T4 is okay.')
	})
</script>
`,

remove:`
<div>1 <button>x</button></div>
<div>2 <button>x</button></div>
<div>3 <button>x</button></div>
<div>4 <button>x</button></div>
<div>5 <button>x</button></div>
<div>6 <button>x</button></div>
<div>7 <button>x</button></div>
<script>
	sq('div button').on('click', function(){
		sq(this).parent().remove()
	})
</script>
`,

before:`
<style>
	div {
		padding: 4px;
		margin: 8px;
	}
</style>
<div id="area1" style="background-color: #aaa">
	area1
	<div id="area2" style="background-color: pink">area2</div>
	<div id="area3" style="background-color: blue">area3</div>
</div>
<script>
	sq('#area2').before('<div>Inserted Text!!!</div>')
</script>
`,

after:`
<style>
	div {
		padding: 4px;
		margin: 8px;
	}
</style>
<div id="area1" style="background-color: #aaa">
	area1
	<div id="area2" style="background-color: pink">area2</div>
	<div id="area3" style="background-color: blue">area3</div>
</div>
<script>
	sq('#area2').after('<div>Inserted Text!!!</div>')
</script>
`,

prepend:`
<style>
	div {
		padding: 4px;
		margin: 8px;
	}
</style>
<div id="area1" style="background-color: #aaa">
	area1
	<div id="area2" style="background-color: pink">area2</div>
	<div id="area3" style="background-color: blue">area3</div>
</div>
<script>
	sq('#area2').prepend('<div>Inserted Text!!!</div>')
</script>
`,

append:`
<style>
	div {
		padding: 4px;
		margin: 8px;
	}
</style>
<div id="area1" style="background-color: #aaa">
	area1
	<div id="area2" style="background-color: pink">area2</div>
	<div id="area3" style="background-color: blue">area3</div>
</div>
<script>
	sq('#area2').append('<div>Inserted Text!!!</div>')
</script>
`,

replaceWith:`
<style>
	div {
		padding: 4px;
		margin: 8px;
	}
</style>
<div id="area1" style="background-color: #aaa">
	area1
	<div id="area2" style="background-color: pink">area2</div>
	<div id="area3" style="background-color: blue">area3</div>
</div>
<script>
	sq('#area2').replaceWith('<div>Inserted Text!!!</div>')
	
	// TIPS: you can also do the same thing using oHtml.
	// sq('#area2').oHtml('<div>Inserted Text!!!</div>')

	// Also, oHtml can also be used to get the outerHTML of an element.
	// example: sq('#area2').oHtml()
</script>
`,

addClass:`
<style>
	.poison {
		color: purple;
		font-weight: bold;
	}
</style>
<div>Your Pokemon</div>
<button>Add poison!</button> <button>Remove poison!</button>

<script>
	sq('button').eq(0).on('click', function(){
		sq('div').addClass('poison')
	})
	sq('button').eq(1).on('click', function(){
		sq('div').removeClass('poison')
	})
</script>
`,

toggleClass:`
<style>
	.poison {
		color: purple;
		font-weight: bold;
	}
</style>
<div>Your Pokemon</div>
<button>poison!</button>

<script>
	sq('button').on('click', function(){
		sq('div').toggleClass('poison')
	})
</script>
`,

width:`
<style>
#memo {
	width: 300px; 
	height: 100px;
	max-width: 500px;
	border: 4px solid blue;
	margin: 3px;
	padding: 13px;
	box-sizing: content-box;
}
</style>
<textarea id="memo">resize this!</textarea>
<br>
<button>Get the width and height</button>
<script>
	sq('button').on('click', function(){
		const el = sq('#memo')
		const w = el.width() + 'px'
		const h = el.height() + 'px'
		el.val( "width: " + w + "　height: " + h )
	})
</script>
`,


innerWidth:`
<style>
#memo {
	width: 300px; 
	height: 100px;
	max-width: 500px;
	border: 4px solid blue;
	margin: 3px;
	padding: 13px;
	box-sizing: content-box;
}
</style>
<textarea id="memo">resize this!</textarea>
<br>
<button>Get the innerWidth and innerHeight</button>
<script>
	sq('button').on('click', function(){
		const el = sq('#memo')
		const w = el.innerWidth() + 'px'
		const h = el.innerHeight() + 'px'
		el.val( "innerWidth: " + w + "　innerHeight: " + h )
	})
</script>
`,


outerWidth:`
<style>
#memo {
	width: 300px; 
	height: 100px;
	max-width: 500px;
	border: 4px solid blue;
	margin: 3px;
	padding: 13px;
	box-sizing: content-box;
}
</style>
<textarea id="memo">resize this!</textarea>
<br>
<button>Get the outerWidth and outerHeight</button>
<script>
	sq('button').on('click', function(){
		const el = sq('#memo')
		const w = el.outerWidth() + 'px'
		const h = el.outerHeight() + 'px'
		el.val( "outerWidth: " + w + "　outerHeight: " + h )
	})
</script>
`,

offset:`
<style>
p {
	margin-left: 10px;
}
</style>

<div>
	<p>Hello</p>
	<p>2nd Paragraph</p>
</div>

<script>
	let p = sq( "p" ).last()
	let offset = p.offset()
	p.html( "left: " + offset.left + ", top: " + offset.top )
</script>
`,

pos:`
<style>
p {
	margin-left: 10px;
}
</style>

<div>
	<p>Hello</p>
	<p>2nd Paragraph</p>
</div>

<script>
	let p = sq( "p" ).first()
	let position = p.pos()
	sq( "p" ).last().text( "left: " + position.left + ", top: " + position.top )
</script>
`,

fadeIn:`
<div>Life is Strange...</div>
<button>FadeIn</button> <button>FadeOut</button> <button>FadeInOut</button> <button>FadeOutIn</button>
<script>
	sq('button').eq(0).on('click', ()=>{
		sq('div').fadeIn(800)
	})
	sq('button').eq(1).on('click', ()=>{
		sq('div').fadeOut(800)
	})
	sq('button').eq(2).on('click', ()=>{
		sq('div').fadeIn(800, ()=>{
			sq('div').fadeOut(800)
		})
	})
	sq('button').eq(3).on('click', ()=>{
		sq('div').fadeOut(800, ()=>{
			sq('div').fadeIn(800)
		})
	})
</script>
`,

animateSimple: `
<style>
#container {
	position: relative;
	width: 100%;
	height: calc(100% - 24px);
	background-color: #eee;
}
#object {
	background-color: #f00;
	width: 20px;
	height: 20px;
	position: absolute;
	top: 0;
	left: 0;
}
</style>
<button>animate</button> 
<div id="container">
	<div id="object"></div>
</div>
<script src="squery.min.js"></script>
<script>
sq('button').on('click', ()=>{
	sq('#object').animate({
		left: '40%',
		top: '20%',
		transform: "scale(10, 3) rotate(130deg)"
	}, 900 )
})
</script>
`,

animate:`
<style>
	#container {
		position: relative;
		width: 100%;
		height: calc(100% - 24px);
		background-color: #eee;
	}
	#object1, #object2, #object3 {
		background-color: red;
		width: 20px;
		height: 20px;
		position: absolute;
		top: 0;
		left: 0;
	}
	#object2 {
		left: 100px;
		background-color: blue;
	}
	#object3 {
		left: 200px;
		background-color: orange;
	}
</style>
<button>animate object 1</button> 
<button>animate object 2</button> 
<button>animate object 3(Infinity)</button> 
<div id="container">
	<div id="object1"></div>
	<div id="object2"></div>
	<div id="object3"></div>
</div>
<script>
	// for object 1
	sq('button').eq(0).on('click', ()=>{
		sq('#object1').animate({
			left: '40px',
			top: '200px'
		}, 600 )
	})

	// for object 2
	sq('button').eq(1).on('click', ()=>{
		// reset pos
		sq('#object2').css({
			left: '100px',
			top: '0px'
		})

		sq('#object2').animate({
			left: '140px',
			top: '200px'
		}, 1000, function(){ //The callback when the animation finishes
			// saving the final state
			sq('#object2').css({
				left: '140px',
				top: '200px'
			})
		})
	})

	// for object 3
	sq('button').eq(2).on('click', function(){
		sq('#object3').animate({
			left: '240px',
			top: '250px'
		}, {iterations: Infinity}, 900 )
		sq(this).prop('disabled', true)
	})
</script>
`,

scroll:`
<body>
	<button>Scroll Smoothly</button> <button>Scroll Instantly</button> <button>Scroll 300px only</button>
	<div style="height:200%; background-color: #eee;margin:10px"></div>
</body>
<script>
	sq('button').eq(0).on('click', ()=>{
		sq('body').scroll( 10000 ) //scroll 10000px from the top
	})
	sq('button').eq(1).on('click', ()=>{
		sq('body').scroll( 10000, true ) //true is for instant scroll
	})
	sq('button').eq(2).on('click', ()=>{
		sq('body').scroll( 300 ) //scroll 300px only
	})
</script>
`,

scrollTop:`
<body>
	<div style="width: 200%; height:200%; background-color: #eee;margin:10px; padding:40px;">
		Click anywhere!<br>
		If you scroll, the values will be different!
	</div>
</body>
<script>
	sq('div').on('click', function(){
		const x = sq('body').scrollLeft()
		const y = sq('body').scrollTop()
		alert( 'left: ' + x + 'px  ' + 'top: ' + y + 'px' )
	})
</script>
`,

scrollToElement:`
<button>scroll to bottom</button>

<div style="height:200%; background-color: #eee;margin:10px"></div>

<button>scroll to top</button>

<script>
	sq('button').eq(0).on('click', ()=>{
		sq('button').eq(1).scrollToElement()
	})
	sq('button').eq(1).on('click', ()=>{
		sq('button').eq(0).scrollToElement()
	})
</script>
`,

each:`
<ul>
  <li>Bulbasaur</li>
  <li>Ivysaur</li>
  <li>Venusaur</li>
  <li>Charmander</li>
  <li>Charmeleon</li>
  <li>Charizard</li>
</ul>

<div id="console"></div>

<script>
	sq( "li" ).each(function( index ) {
		sq('#console').append( 'No. ' + (index+1) + ': ' + sq( this ).text() + '<br>' )
	})
</script>
`,

on:`
<button id="hello">I say hello infinitely!</button>
<button id="hello2">I say hello only one time!</button>
<script>
	sq('#hello').on('click', function(){
		alert('hello!')
	})
	sq('#hello2').on('click', function(){
		alert('Hello! And... good-bye!')
		sq(this).off('click').css('color', '#999')
	})
</script>
`,

onf:`
<body></body>
<script>
	// This won't work!
	sq('#hello1').on('click', function(){
		alert('hello 1!')
	})
	// This will work!
	sq('body').onf('click', '#hello2', function(){
		alert('hello 2!')
	})
	sq('body').append('<button id="hello1">hello 1</button> ')
	sq('body').append('<button id="hello2">hello 2</button> ')
</script>
`,

trg:`
<ul>
  <li>Bulbasaur</li>
  <li>Ivysaur</li>
  <li>Venusaur</li>
  <li>Charmander</li>
  <li>Charmeleon</li>
  <li>Charizard</li>
</ul>

<script>
	sq('li').on('click', function(){
		let idx = sq(this).index()
		sq('li').css('color', 'black')
		sq('li').eq( idx ).css('color', 'red')
	})
	sq('li').eq(3).trg('click') //Triggering a Charmander click
	//sq('li').eq(3).trigger() //this also works!
</script>
`,

// examples
fetch:`
<div id="console">loading...</div>
<script>
	my_ajax('https://ptsv2.com/t/ends/post', {name: 'Steve Jobs', age: 21} )
	

	function my_ajax( url, data ){
		fetch( 
			url, 
			{
				method: 'POST',
				headers: {'Content-Type': 'application/x-www-form-urlencoded'},
				body: "data=" + JSON.stringify( data )
			}
		).then( res => {
			console.log( res )
			if ( res.status == 200 )
				sq('#console').html( 'sent!' )
		}).catch( error => {
			console.log( error )
		})
	}
</script>
`,

axios:`
<div id="console">loading...</div>
<script src="https://cdn.jsdelivr.net/npm/axios/dist/axios.min.js"></script>
<script>
	axios({
		method: 'GET',
		url: 'https://api.github.com/users/shawnquinn',
	})
	.then( function( res ){
		if ( res.status == 200 )
			sq('#console').html( 'GET succeeded!' )
		console.log( res.data )
	})
	.catch( function(error){
		console.log(error)
	})
</script>
`

}

export {g_codes};